@if (!options().hostClass) {
  <button
    #btn
    [id]="options().id"
    (click)="options().hostClass ? doNothing($event) : onClick($event)"
    [class]="'btn btn-md btn-primary text-nowrap ' + (options().class || '')"
    placement="bottom"
    [ngbTooltip]="options().tooltip ? translations.tooltips[options().tooltip!] : null"
    tooltipClass="my-custom-class"
    [openDelay]="0"
    [closeDelay]="0"
    [type]="options().type"
    [attr.form]="options().formId"
    [disabled]="options().disabled"
  >
    @if (options().isLoading) {
      <div class="loading spinner-border text-light" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    } @else if (options().icon) {
      <i [class]="options().icon"></i>
    }
    <ng-content>
      @if (options().text) {
        {{ translations[options().text!] || options().text! }}
      }
    </ng-content>
  </button>
}
